import { NgModule } from '@angular/core';
import { AppVersionPipe } from './app-version.pipe';

@NgModule({
    declarations: [AppVersionPipe],
    exports: [AppVersionPipe]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts